import { logUsage } from 'owa-analytics';
import { ClientItem, mailStore } from 'owa-mail-store';

export default function logAttachButtonClickedDatapoint(referenceItemId: string): void {
    // Get reference item (if any).
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (9,11): Type 'ClientItem | undefined' is not assignable to type 'ClientItem'.
    // @ts-expect-error
    const referenceItem: ClientItem = mailStore.items.get(referenceItemId);

    // Log that the Attach button itself was clicked.
    logUsage('AttachButtonClicked', [
        true /* isMail */,
        referenceItem?.SmartDocData?.EntityId /* for SmartDoc pill */ /* for SmartDoc pill */,
    ]);
}
